import colors from './colors';

export const defaultTheme = { colors };
